import { derived } from "svelte/store";
import { locale, addMessages, init } from "svelte-i18n";

import en from "./en.json";
import it from "./it.json";

addMessages("en", en);
addMessages("it", it);

export const languageInit = () => {
  const localLanguage = localStorage.getItem("language");
  if (localLanguage) {
    locale.set(localLanguage);
  } else {
    setLanguage("en");
  }
  init({
    fallbackLocale: "it",
    initialLocale: "it",
  });
};

export const setLanguage = (lang) => {
  console.log(lang);
  locale.set(lang);
  localStorage.setItem("language", lang);
};

export const getLanguage = derived(locale, ($locale) => $locale);
